export enum ViewState {
    COMPLETED = 'COMPLETED',
    ACTIVE = 'ACTIVE',
    UPCOMING = 'UPCOMING',
    DRAFT = 'DRAFT',
}

export enum ViewType {
    CUSTOM = 'CUSTOM',
    ADVERTISING = 'ADVERTISING',
    OOH = "OOH",
    RETAIL = 'RETAIL',
    SMART_CITY = 'SMART_CITY'
}

export enum ViewSection {
    PERFROMANCE= 'performance',
    Pom = 'PoM',
    MAP = 'map'
}

export enum ViewCalendarSelection {
    ALL_TIME = 'All time',
    DAY = 'Day',
    WEEK = 'Week',
    MONTH = 'Month',
    // LAST_30_DAYS = 'Last 30 days',
    QUARTER = 'Quarter',
    // YEAR = 'Year',
    CUSTOM = 'Custom'
}